import { FaHome, FaTruck } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { GiFarmer } from "react-icons/gi";
import { PiPlantFill } from "react-icons/pi";
import { MdProductionQuantityLimits, MdOutlineScreenShare, MdOutlineLocationOn, MdOutlineCloudUpload, MdOutlineHelpOutline } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";


export interface SidebarItem {
  name: string;
  icon: any;
  url: string;
}

export const sidebarItems: SidebarItem[] = [
  {
    name: "Home",
    icon: FaHome,
    url: "/admin/dashboard",
  },
  {
    name: "Employees",
    icon: FaUserGroup,
    url: "/admin/employees",
  },
  {
    name: "Products",
    icon: MdProductionQuantityLimits,
    url: "/admin/products",
  },
  {
    name: "Farmers",
    icon: GiFarmer,
    url: "/admin/farmers",
  },
  {
    name: "Crops",
    icon: PiPlantFill,
    url: "/admin/crops",
  },
  {
    name: "Distributors",
    icon: FaTruck,
    url: "/admin/distributors",
  },
  {
    name: "Summary Report",
    icon: TbReportAnalytics,
    url: "/admin/report"
  },
  {
    name: "Demo Report",
    icon: MdOutlineScreenShare,
    url: "/admin/demo"
  },
  {
    name: "Visit Report",
    icon: MdOutlineLocationOn,
    url: "/admin/visit"
  },
  {
    name: "Upload Logo",
    icon: MdOutlineCloudUpload,
    url: "/admin/upload"
  },
  {
    name: "Help",
    icon: MdOutlineHelpOutline,
    url: "/admin/help"
  }
];
